export default __webpack_public_path__ + "static/media/videohotel.94ca59a1.mp4";